import {
  CustomerDocument,
  useCustomerQuery,
  useCustomerSession,
} from '@graphcommerce/magento-customer'
import { Box } from '@mui/material'
import React from 'react'
import { FormCustomer } from './forms/FormCustomer'
import { FormGuest } from './forms/FormGuest'

export type OutOfStockSubscribeProps = React.ComponentProps<typeof OutOfStockSubscribe>

export function OutOfStockSubscribe(props: {
  productUid: string
  wishlistButton?: React.ReactNode
}) {
  const { productUid, wishlistButton } = props

  const { data: customer } = useCustomerQuery(CustomerDocument)
  const { loggedIn } = useCustomerSession()

  return (
    <Box sx={{ display: 'grid' }}>
      {loggedIn && !!customer ? (
        <FormCustomer customer={customer} productUid={productUid} wishlistButton={wishlistButton} />
      ) : (
        <FormGuest productUid={productUid} wishlistButton={wishlistButton} />
      )}
    </Box>
  )
}
